export const convertDate = input => {
  const inputDate = new Date(input);
  const month = inputDate.getMonth();
  const year = inputDate.getFullYear();
  const day = inputDate.getDate();

  const formattedDate = `${day <= 9 ? '0' + day : day}-${
    month <= 9 ? '0' + month : month
  }-${year}`;
  return formattedDate;
};
